import { Menu } from "@shapr3d/frontend-lib";

import { webAppURL } from "../../../../config";
import type { AccountData } from "../../../../hooks/useAccountTypes";
import { useLogout } from "../../../../hooks/useAuth";
import { useTracker } from "../../../../hooks/useTracker";
import { ElementClickAction, ElementClickLocation } from "../../../../lib/TrackingAdapter";
import { AccountButton } from "../AccountButton/AccountButton";

import style from "./MenuHeader.module.css";

export const MenuHeader = ({ accountData }: { accountData?: AccountData }) => {
  const tracker = useTracker();
  const { mutateAsync: mutateLogout, isPending: isLogoutPending } = useLogout({
    redirect: true,
    withRequest: true,
  });
  return (
    <>
      <div className={style.separator} />
      <div className={style.menuContainer}>
        <Menu
          activator={<AccountButton name={accountData?.name ?? accountData?.email} />}
          onOpen={() => {
            tracker.trackButtonClick({ action: ElementClickAction.OPEN_ACCOUNT_MENU });
          }}
          onClose={() => {
            tracker.trackButtonClick({ action: ElementClickAction.CLOSE_ACCOUNT_MENU });
          }}
        >
          <Menu.Link
            href={webAppURL}
            target="_blank"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_ACCOUNT_SETTINGS,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
            }}
            closeOnClick
          >
            Account settings
          </Menu.Link>
          <Menu.Divider />
          <Menu.Link
            href="https://support.shapr3d.com/hc/en-us"
            target="_blank"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_HELP_CENTER,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
            }}
            closeOnClick
          >
            Help Center
          </Menu.Link>
          <Menu.Link
            href="https://support.shapr3d.com/hc/en-us/articles/12208897524380-Video-tutorials"
            target="_blank"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_VIDEO_TUTORIALS,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
            }}
            closeOnClick
          >
            Video tutorials
          </Menu.Link>
          <Menu.Link
            href="https://discourse.shapr3d.com"
            target="_blank"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_COMMUNITY,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
            }}
            closeOnClick
          >
            Community
          </Menu.Link>
          <Menu.Divider />
          <Menu.Link
            href="https://www.shapr3d.com/download"
            target="_blank"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.GO_TO_DOWNLOAD,
                location: ElementClickLocation.TOP_RIGHT_MENU,
              });
            }}
            closeOnClick
          >
            Download Shapr3D
          </Menu.Link>
          <Menu.Divider />
          <Menu.Item disabled={isLogoutPending} onClick={() => mutateLogout()}>
            Log out
          </Menu.Item>
        </Menu>
      </div>
    </>
  );
};
